import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { OnChanges } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import type { StudentCart } from '../student-chiclet/student-chiclet.component';
import { StudentChicletComponent } from '../student-chiclet/student-chiclet.component';

@Component({
  selector: 'lt-student-chiclet-bar',
  imports: [CommonModule, StudentChicletComponent],
  templateUrl: './student-chiclet-bar.component.html',
  styleUrls: ['./student-chiclet-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudentChicletBarComponent implements OnChanges {
  students = input<StudentCart[]>([]);
  studentSelected = output<string>();

  ngOnChanges(): void {}

  onStudentSelected(studentId: string): void {
    this.studentSelected.emit(studentId);
  }
}

App.directive('ltStudentChicletBar', downgradeComponent({ component: StudentChicletBarComponent }));
